var React = require('react');
import { Link, browserHistory } from 'react-router';
var PropTypes = React.PropTypes;
var Auth = require("../../resources/auth");

import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import '../../css/components/Students/students.css';
import { Pager } from 'react-bootstrap';

// import StudentClassesTable from './StudentClassesTable';
import TeachersTable from '../SchoolEditor/TeachersTable';
var SchoolRes = require('../../resources/school');

const STUDENT_STATUSES = [{
    // title: 'Draft',
    // code: 'draft',
    // value: ['self'],
    // actions: ['edit', 'delete'],
    // count: '-',
    cols: ['firstName', 'lastName', 'email', 'phone', 'lastActivityDate'],
    notes: [
      ''
    ]
}];

const ITEM_LIMIT = 20;
var ViewSchool = React.createClass({
  componentWillReceiveProps: function(nextProps) {
    this.setState({})
  },
  onSortChange: function(newSort) {
    this.setState({
      sort: newSort,
      teachersInThisSchoolData: [],
      isLoading: true,
      currentPager: 1,
    }, () => {
      this.retrieveTeachersInThisSchool();
    });
  },
  getInitialState: function() {
    return {
    //   searchStudentClassName: '',
      statusMode: [],
      currentMode: {},
      teachersInThisSchoolData: [],
      thisSchoolName: "",
      isLoading: true,
      // conceptsMap: null,
      currentPager: 1,
      sort: 'firstName',
      ifViewingFromClass: true
    };
  },
//   handleChangeData: function(e) {
//     // var update = {};
//     // update[field] = e.target.value;
//     // this.setState(update);
//     // var searchName = this.state.searchStudentName;
//     this.setState({
//     //   searchStudentClassName: e.target.value,
//       studentClassesData: [],
//       isLoading: true,
//       currentPager: 1,
//       sort: 'studentClassName'
//     }, () => {
//       this.retrieveStudentClasses(this.state.searchStudentClassName);
//     });
//   },
  componentDidMount: function() {

    var _this = this;
    var statusMode = this.state.statusMode;
    statusMode = STUDENT_STATUSES;
    var currentUser = Auth.getCurrentUser();
    // if (currentUser.status.indexOf('reviewer') >= 0) return browserHistory.push('/review-tasks');
    // if (currentUser.role === 'admin') {
    //   statusMode = ADMIN_STATUSES;
    // } else  {
    //   statusMode = TEACHER_STATUSES;
    // }
    var currentMode = statusMode[0];
    if (this.props.location.query.mode) {
      var mode = this.props.location.query.mode,
          mappedMode = statusMode.filter((value) => {
            return value.code === mode
          })[0];
      if (mappedMode) currentMode = mappedMode;
    }
    this.setState({
      isLoading: true,
      statusMode: statusMode,
      currentMode: currentMode
    }, function() {
      // var count = statusMode.length;
      // for (var i = 0; i < statusMode.length; i++) {
      //   this.countCollectionInMode(statusMode[i], function() {
      //     count--;
      //     if (count <= 0) _this.forceUpdate();
      //   });
      // }
      this.retrieveTeachersInThisSchool();
    });
  },
//   showStudentClass: function(studentClassID) {

//     // alert("STUDENT CLASS ID IS " + studentClassID);
//     browserHistory.push('/class/' + studentClassID);
//   },
  // retrieveSingleStudentClass: function(studentClassID,callback) {

    
  // },
  retrieveTeachersInThisSchool: function(callback) {
    callback = callback || function(){};
    var _this = this;
    var currentPager = this.state.currentPager;
    var options = {};
    // options.skip = ITEM_LIMIT * (currentPager - 1);
    // options.limit = ITEM_LIMIT;
    // options.sort = this.state.sort || "dateCreated";
    options.conditions = {};
    // options.conditions.status = {
    //   "$in": this.state.currentMode.value
    // }
    // if (!this.state.currentMode.canApplyAdminRole) {
    //   options.conditions.creator = Auth.getCurrentUser()._id;
    // }
    // if (this.state.currentMode.include) {
    //   options.include = this.state.currentMode.include;
    //   options.includeConditions = includeConditions[options.include];
    // }
          // console.log("state of mdoe is " + this.state.currentMode.cols);
    
    var scName = '';
    // if (studentClassName) { scName = studentClassName; }

    var currentURL = window.location.href;
    currentURL = currentURL.split("/");
    var sSchoolID = currentURL[currentURL.length-1]; //get the current class ID

    options.conditions.sort = this.state.sort || "firstName";
    // options.conditions.status = 'student';
    options.conditions.schoolID = sSchoolID;

    // options.conditions.lastName = lastN;
    SchoolRes.retrieveTeachersInThisSchool(options, function(err, res) {
      // console.log("BEFORE DON sdfdsfsE!!");
      // if (callback) return callback(err, res);
      // console.log("BEFORE DONE!!");
      _this.setState({
        isLoading: false,
        teachersInThisSchoolData: (!err && res) ? res: [{}]
      }, () => {

        var sData = _this.state.teachersInThisSchoolData;
        var sSchoolData = sData["teachersInSelectedSchool"];
        var sSchoolName = sData["schoolName"];

        for (var i = 0; i < sSchoolData.length; i++) {

          var thisData = sSchoolData[i];
          var dDate = thisData['lastActivityDate'];
          var processDate = new Date(dDate);
          var dateToDisplay = processDate.toDateString();
          if (processDate.getFullYear()=='1970') { dateToDisplay = '-';}
          thisData['lastActivityDate'] = dateToDisplay;//processDate.getFullYear() + "/" + processDate.getMonth() + "/" + processDate.getDate();
        }

        _this.setState({
            teachersInThisSchoolData: sSchoolData,
            thisSchoolName:sSchoolName
        });
      }
      // , function() {
        // _this.retrieveCollectionQuestionStat(function() {
          // if (_this.state.currentMode.showReviewStat) {
          //   var collections = _this.state.collectionData;
          //   for (var i = 0; i < collections.length; i++) {
          //     _this.retrieveCollectionTaskStat(collections[i]);
          //   }
          // }
        // });
        // return callback(err, res);
      // }
      );
    })
  },
  navigatePager: function(dir) {
    var currentPager = this.state.currentPager,
              _this  =  this;
    currentPager += dir;
    _this.setState({
      currentPager: currentPager,
      isLoading: true
    }, function() {
      this.retrieveTeachersInThisSchool();
      // this.retrieveStudents(function(err, res) {
      // })
    })
  },
  render: function() {
    var _this = this;
    return (
        <div className="students">
            <h3> {_this.state.thisSchoolName} </h3>
            <div className="content-toolbar">
            </div>

            <hr />
            {
              
              (_this.state.teachersInThisSchoolData.length > 0 && !_this.state.isLoading) &&
              
              <TeachersTable
                data={this.state.teachersInThisSchoolData}
                mode={this.state.currentMode}
                sort={this.state.sort}
                // showStudentClass={this.showStudentClass}
                //onDelete={this.deleteCollection}
                onSortChange={this.onSortChange}
                ifViewingFromClass={this.state.ifViewingFromClass}
                //onUpdateSingleCollection={this.updateSingleCollection}
              />
            }
            {
            _this.state.isLoading &&
            <CircularProgress />
            }
            <Pager>
              {
                _this.state.currentPager > 1 &&
                <Pager.Item
                  onClick={_this.navigatePager.bind(_this, -1)}
                  disabled={_this.state.currentPager === 1}
                >
                  Previous
                </Pager.Item>
              }
              {' '}
              {
                _this.state.teachersInThisSchoolData.length >= ITEM_LIMIT &&
                <Pager.Item
                  onClick={_this.navigatePager.bind(_this, 1)}
                  disabled={_this.state.teachersInThisSchoolData.length < ITEM_LIMIT}
                >
                  Next
                </Pager.Item>
              }
            </Pager>
        </div>
    );
  }

});

module.exports = ViewSchool;



/** WEBPACK FOOTER **
 ** ./src/components/Schools/ViewSchool.js
 **/